import React from 'react';
import PropTypes from "prop-types";
import request from "superagent";
import _ from "lodash";
import {Alert, Button, ControlLabel, FormGroup, Panel, ProgressBar} from "react-bootstrap";
import SharepointDriveSelector from "./SharepointDriveSelector";
import SharepointSiteSearch from "./SharepointSiteSearch"
import {notify} from "../../components/common/Notification";

export default class SharepointConnectionSettings extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number.isRequired,
  };

  initialState = {
    isLoading: true,
    error: null,
    selectedSite: null,
    selectedDrive: null,
  };

  state = {...this.initialState};

  componentDidMount() {
    this.loadDefaultDrive();
  }

  loadDefaultDrive(refreshFromSharepoint) {
    this.setState(this.initialState);

    return request.get(`/rpc/integrations/connections/${this.props.connectionId}/sharepoint/drive`)
      .query({refresh: refreshFromSharepoint})
      .then(res => {
        this.setState({
          isLoading: false,
          selectedSite: res.body.site,
          selectedDrive: res.body.drive,
        });
      })
      .catch(err => {
        this.setState({
          isLoading: false,
          error: _.get(err, 'response.status') !== 404 ? true : false
        });
      });
  }

  onSelectSite = (selectedSite) => {
    this.setState({
      selectedDrive: null, // clear drive selection when site changes
      selectedSite,
    });
  }

  onSelectDrive = (selectedDrive) => {
    this.setState({ selectedDrive });
  }

  onSave = () => {
    this.setState({isLoading: true});

    request.post(`/rpc/integrations/connections/${this.props.connectionId}/sharepoint/drive`)
      .send({
        drive_type: 'site', // TODO - support personal drive or site drive selection?
        site: this.state.selectedSite,
        drive: this.state.selectedDrive,
      })
      .then(res => {
        this.setState({isLoading: false});
        notify.success("Default SharePoint drive saved");
      })
      .catch(err => {
        this.setState({isLoading: false});
        notify.error("Failed to save SharePoint default drive");
      });
  };

  render() {
    const {selectedSite} = this.state;

    return (
      <Panel>
        <Panel.Heading>
          <Panel.Title componentClass="h3">
            SharePoint Settings
          </Panel.Title>
        </Panel.Heading>

        <Panel.Body>{(() => {
          if (this.state.error) return (
            <Alert bsStyle="danger">
              There was an error loading SharePoint Settings Information.
              If the problem persists, please contact CourtDrive support.
            </Alert>
          );

          if (this.state.isLoading) return (
            <ProgressBar active now={100} />
          );

          return (
            <div>
              <FormGroup>
                <ControlLabel>Sharepoint Site</ControlLabel>
                <SharepointSiteSearch
                  connectionId={this.props.connectionId}
                  defaultValue={selectedSite}
                  onSelectSite={this.onSelectSite}
                />
              </FormGroup>

              {selectedSite &&
                <FormGroup>
                  <ControlLabel>Sharepoint Document Library</ControlLabel>
                  <SharepointDriveSelector
                    connectionId={this.props.connectionId}
                    siteId={selectedSite.id}
                    onSelectDrive={this.onSelectDrive}
                  />
                </FormGroup>
              }

              {this.state.selectedDrive &&
                <div>
                  <Button bsStyle="primary" onClick={this.onSave}>Save</Button>
                </div>
              }
            </div>
          );
        })()}
        </Panel.Body>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/SharepointConnectionSettings.jsx